import { useEffect, useState, useCallback, useRef } from 'react';
import { io, Socket } from 'socket.io-client';

interface UseDeviceSocketProps {
  driverUid: string;
}

export const useCommandSocket = ({ driverUid }: UseDeviceSocketProps) => {
  const socketRef = useRef<Socket | null>(null);

  const [eldResponses, setEldResponses] = useState<any[]>([]);
  const [cameraResponses, setCameraResponses] = useState<any[]>([]);
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');

    const apiUrl = process.env.REACT_APP_API_URL || 'https://uat.tteld.com/';
    const baseUrl = apiUrl.replace(/\/api\/?$/, '');

    const socket = io(baseUrl, {
      path: '/socket.io',
      transports: ['websocket'],
      auth: { which: 'admin', token },
      reconnection: true,
      reconnectionDelay: 2000,
      reconnectionDelayMax: 10000,
      reconnectionAttempts: Infinity,
      timeout: 20000,
    });

    socketRef.current = socket;

    socket.on('connect', () => {
      setIsConnected(true);
      socket.emit('join-to-device-status', { driverUid });
    });

    socket.on('disconnect', () => {
      console.warn('⚠️ Socket disconnected');
      setIsConnected(false);
    });

    socket.on('connect_error', (err) => {
      console.error('Socket connect_error:', err.message);
    });

    socket.on('device-response', (data) => {
      if (!data || !data.command) return;

      if (data.command === 'eld_response') {
        setEldResponses((prev) => [data, ...prev]);
      } else if (data.command === 'camera_response') {
        setCameraResponses((prev) => [data, ...prev]);
      } else {
      }
    });

    return () => {
      socket.emit('leave-from-driver', { driverUid });
      socket.disconnect();
    };
  }, [driverUid]);

  const sendCommand = useCallback(
    (command: string, text?: string) => {
      if (!socketRef.current || !isConnected) return;
      const payload = { driverUid, command: { command, text } };
      socketRef.current.emit('device-request', payload);
    },
    [driverUid, isConnected],
  );

  return { eldResponses, cameraResponses, sendCommand, isConnected };
};
